import React, { useEffect } from 'react';
import { Channel } from '../../shared/types';
import { Grid } from '@mui/material';
import ChannelCard from '../containers/client/ChannelCardNew';
import { baseUrls } from '../../utils/baseUrls.utils';
import Loader from './LoadingIndicator';

interface ChannelPreviewListProps {
    onDataLoaded?: (totalCount: number) => void;
    channels: Channel[];
    loading: boolean;
}

const ChannelPreviewList = ({
    onDataLoaded,
    channels,
    loading,
}: ChannelPreviewListProps) => {
    useEffect(() => {
        if (!loading && onDataLoaded) {
            onDataLoaded?.(channels.length ?? 0);
        }
    }, [channels, loading, onDataLoaded]);

    if (loading) {
        return <Loader minHeight={128} />;
    }
    if (!channels?.length) return null;

    return (
        <Grid container spacing={2}>
            {channels.map((channel: Channel) => {
                if (!channel) return <></>;

                return (
                    <Grid
                        key={channel._id}
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 4,
                        }}
                    >
                        <ChannelCard
                            name={channel.name}
                            owner={channel.owner.name}
                            url={`${baseUrls.browse.channelMain}/${channel._id}`}
                            image={channel.coverImage}
                            premium={channel.type === 'premium'}
                            isSubscribed={channel.isCurrentUserSubscribed}
                            fullHeight
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default ChannelPreviewList;
